import caret_purple_down from 'src/assets/caret_purple_down.png';
import add_button from 'src/assets/add_button.png';
import gray_edit from 'src/assets/gray_edit.png';
import gray_bin from 'src/assets/gray_bin.png';
import left_arrow from 'src/assets/left_arrow.png';
import green_dot from 'src/assets/green_dot.png';
import caret_up from 'src/assets/caret_up.png';
import close_icon_purple from 'src/assets/close_icon_purple.png';

import React, { useState, useEffect } from 'react'
import {
  AnswerOverviewColoredContainer,
  AnswerOverviewContainerParent,
  AssessmentResultOverviewColoredContainer,
  ChangeButtonsContainer,
  ContainerTopRight,
  DarkOverlayBehindDrawer,
  EntriesContainer,
  GreenDotImage,
  IndexButton,
  IndexContainer,
  JournalButton,
  JournalEntryTime,
  JournalEntryTitle,
  ModalCloseButton,
  MyAssessmentChartAndDetailsContainer,
  MyAssessmentHeader,
  MyAssessmentNameInHeader,
  MyAssessmentSeeMoreText,
  MyAssessmentUserInputQA,
  RecommendationClosedParentContainer,
  RecommendationDrawer,
  RecommendationOpenParentContainer,
  RecommendationText,
  RecommendedItemContainer,
  RecommendedItemImage,
  RecommendsClosedTitle,
  ScreenBackground,
  StyledHeading,
  UserJournalTextArea,
  YourInputsText,
} from '../JournalStyles'
import {
  GenericModal,
  JournalInIndexComponent,
  LoadingIconGroup,
  StartJournalingScreen,
} from '../JournalComponents'
import {
  deleteJournalEntry,
  getArticleById,
  getDataWithoutParams,
  getJournalBasedRecommendation,
} from 'src/consumer/services/featureServices'
import dayjs from 'dayjs'
import { prepareDataForEditingJournal } from 'src/consumer/helpers/dailyPlayHelper'
import { JournalContext } from 'src/consumer/context/JournalContext'
import { useContext } from 'react'
import { mediaURL } from 'src/consumer/services'
import { useRef } from 'react'
import {
  addDateObjectsToJournals,
  getDataFromRecommendation,
} from 'src/consumer/helpers/journalHelper'
import { SetupContext } from 'src/consumer/context/SetupContext'
import { PlayerContext } from 'src/consumer/context/PlayerContext'
import { resetPlayerData } from 'src/consumer/helpers/playerHelper'
import { ReflectiveQuestion } from '../../DailyPlay/QuoteAndReflection/QuoteAndReflectionComponents'
import Spinner from 'react-bootstrap/Spinner'
import InfiniteScroll from 'react-infinite-scroll-component'
import { ProfileContext } from 'src/consumer/context/ProfileContext'
import { InformationContext } from 'src/consumer/context/InformationContext'
import {
  AssessmentPlayerChartDescriptionSpan,
  DetailedReportComponent,
  DetailedReportDrawer,
  SpeedometerComponent,
} from '../../AssessmentPlayer/AssessmentPlayerStyles'
import { DisplayFlexColumn } from '../../DailyPlay/DailyPlayStyles'
import { GenericDisplayFlexColumn } from 'src/mentor/layout/Styles'

export default function UserJournals({
  setParentModalState,
  setNewEntryData,
  afterSubmitFunction = () => {},
}) {
  const scrollRefEntries = useRef(null)
  const [scrollTop, setScrollTop] = useState(0)

  const [pageState, setPageState] = useState('loading')
  const [userJournalData, setUserJournalData] = useState('')
  const [datedData, setDatedData] = useState([])
  const [recommendationData, setRecommendationData] = useState('')
  const [recommendationDrawerOpen, setRecommendationDrawerOpen] = useState(false)
  const [selectedJournalIndex, setSelectedJournalIndex] = useState(1)
  const [assessmentDetailedReportData, setAssessmentDetailedReportData] = useState([])

  const { journalData, setJournalData } = useContext(JournalContext)
  const { playerData, setPlayerData } = useContext(PlayerContext)
  const { profileData } = useContext(ProfileContext)
  const { setupData } = useContext(SetupContext)
  const { informationModalData, setInformationModalData } = useContext(InformationContext)

  const [deleteWarningVisible, setDeleteWarningVisible] = useState(false)
  const [editReflectionVisible, setEditReflectionVisible] = useState(false)
  const [indexAnswerVisible, setIndexAnswerVisible] = useState(false)
  const [page, setPage] = useState(1)
  const [hasMore, setHasMore] = useState(true)
  const [detailedReportDrawerOpen, setDetailedReportDrawerOpen] = useState(false)
  const [detailedReportWantedTab, setDetailedReportWantedTab] = useState(null)

  async function pageSetup() {
    const response = await getDataWithoutParams(
      `/api/secure/user/journal/entries?page=1&pageSize=10`,
    )
    if (response?.status === 200) {
      if (response?.data?.length === 0) {
        setPageState('no_journals')
      } else {
        setUserJournalData(response?.data)
        const recommendationResponse = await getJournalBasedRecommendation(
          response?.data?.[0]?.journalId,
        )
        if (recommendationResponse?.status === 200) {
          setRecommendationData(getDataFromRecommendation(recommendationResponse?.data))
        }
        setPageState('user_journals')
      }
    }
  }

  async function fetchData() {
    setPage((prev) => prev + 1)
    const response = await getDataWithoutParams(
      `/api/secure/user/journal/entries?page=${page + 1}&pageSize=10`,
    )
    if (response?.status === 200) {
      if (response?.data?.length === 0) {
        setHasMore(false)
      }
      setUserJournalData([...userJournalData, ...response?.data])
    }
  }

  useEffect(() => {
    pageSetup()
  }, [])

  useEffect(() => {
    pageSetup()
  }, [editReflectionVisible])

  async function handleDeleteJournal() {
    const response = await deleteJournalEntry(datedData?.[selectedJournalIndex]?.id)
    if (response.status === 200) {
      setPageState('loading')
      pageSetup()
    } else {
      console.log('error deleting journal entry')
    }
  }

  function handleEditJournal(data) {
    if (data?.journalType === 'regular') {
      const responseData = prepareDataForEditingJournal(data)
      setParentModalState('new_journal')
      setNewEntryData(responseData)
      setJournalData((prev) => {
        return { ...prev, pageState: 'new_journal', subscription: responseData?.subscription?.id }
      })
    } else if (data?.journalType === 'reflection') {
      setEditReflectionVisible(true)
    }
  }

  function handleRecommendationClick() {
    setJournalData({
      showJournal: false,
      callSource: '',
      data: '',
      pageState: '',
      subscription: '',
    })
    if (recommendationData?.itemType === 'course') {
      let cardData = recommendationData?.cardData
      setPlayerData({
        ...resetPlayerData(playerData),
        showPlayer: true,
        selectedCard: playerData.showPIP ? playerData?.selectedCard : cardData,
        source: 'recommendation',
        id: 'recommendation',
      })
    }
    if (recommendationData?.itemType === 'breathe' || recommendationData?.itemType === 'practice') {
      setInformationModalData({ showModal: true, data: { toShow: 'app_exclusive' } })
    }
  }

  useEffect(() => {
    setDatedData(addDateObjectsToJournals(userJournalData))
  }, [userJournalData])

  useEffect(() => {
    if (datedData?.[selectedJournalIndex]?.journalType === 'assessment') {
      setAssessmentDetailedReportData([])

      datedData?.[selectedJournalIndex]?.assessmentResultList?.forEach(async (item) => {
        const scoringRangeItem = item?.scoringRangeList?.find(
          (itemInScoringList) =>
            itemInScoringList?.min <= item?.userScore && itemInScoringList?.max >= item?.userScore,
        )

        const responseGetArticle = await getArticleById(scoringRangeItem?.articleId)

        setAssessmentDetailedReportData((prev) => [
          ...prev,
          { domain: item?.domainId, articleData: responseGetArticle?.data },
        ])
      })
    }
  }, [selectedJournalIndex, pageState])

  const lang = sessionStorage.getItem('languageCode')
  let heading
  if (lang === 'en') {
    heading = `${profileData?.firstName}'s Mindfulness Journal`
  } else {
    heading = 'Your Mindfulness Journal'
  }

  return (
    <>
      {pageState === 'loading' && (
        <ScreenBackground>
          <LoadingIconGroup />
        </ScreenBackground>
      )}

      {pageState === 'no_journals' && (
        <StartJournalingScreen
          heading="Your Mindfulness Journal"
          maintext="Create your first Entry"
          subtext="You have not attempted any journals yet!"
          setParentModalState={setParentModalState}
        />
      )}

      {pageState === 'user_journals' && (
        <ScreenBackground>
          <IndexContainer>
            <div className="d-flex justify-content-between align-items-center flex-wrap">
              <StyledHeading>{heading}</StyledHeading>
              <div className="d-flex align-items-center gap-3">
                <IndexButton
                  caret
                  src={caret_purple_down}
                  onClick={() => setIndexAnswerVisible((prev) => !prev)}
                  up={indexAnswerVisible}
                />
                <IndexButton
                  src={add_button}
                  onClick={() => setParentModalState('browse_journals')}
                />
              </div>
            </div>

            <EntriesContainer ref={scrollRefEntries} id="ScrollableIndex">
              <InfiniteScroll
                dataLength={datedData?.length}
                next={fetchData}
                hasMore={hasMore}
                loader={<Spinner animation="border" variant="dark" size="md" />}
                scrollableTarget="ScrollableIndex"
                style={{ width: '100%', display: 'flex', flexDirection: 'column' }}
              >
                {datedData?.map((entry, index) => {
                  return (
                    <JournalInIndexComponent
                      key={index}
                      data={entry}
                      itemIndex={index}
                      selectedJournalIndex={selectedJournalIndex}
                      setSelectedJournalIndex={setSelectedJournalIndex}
                      indexAnswerVisible={indexAnswerVisible}
                      editJournalFunc={() => handleEditJournal(datedData?.[selectedJournalIndex])}
                      deleteJournalFunc={() => setDeleteWarningVisible(true)}
                    />
                  )
                })}
              </InfiniteScroll>
            </EntriesContainer>
          </IndexContainer>

          <AnswerOverviewContainerParent>
            {datedData?.[selectedJournalIndex]?.journalType !== 'assessment' && (
              <AnswerOverviewColoredContainer
                reflection={datedData?.[selectedJournalIndex]?.journalType === 'reflection'}
              >
                <JournalEntryTime>
                  {moment
                    .utc(datedData?.[selectedJournalIndex]?.createdTime)
                    .utcOffset(dayjs().utcOffset())
                    .format('h:mm a, D MMM')}
                </JournalEntryTime>

                <ContainerTopRight>
                  <JournalButton
                    src={gray_edit}
                    onClick={() => handleEditJournal(datedData?.[selectedJournalIndex])}
                  />
                  <JournalButton
                    src={gray_bin}
                    onClick={() => setDeleteWarningVisible(true)}
                  />
                </ContainerTopRight>

                {datedData?.[selectedJournalIndex]?.journalQusAns?.map((userQA, index) => {
                  return (
                    <div key={index}>
                      <JournalEntryTitle main>{userQA?.question}</JournalEntryTitle>
                      <UserJournalTextArea value={userQA?.answere} readOnly />
                    </div>
                  )
                })}
              </AnswerOverviewColoredContainer>
            )}

            {datedData?.[selectedJournalIndex]?.journalType === 'assessment' && (
              <AssessmentResultOverviewColoredContainer>
                <MyAssessmentHeader>
                  <MyAssessmentNameInHeader>
                    {datedData?.[selectedJournalIndex]?.assessment?.title}
                  </MyAssessmentNameInHeader>
                  <div>
                    {moment
                      .utc(datedData?.[selectedJournalIndex]?.createdTime)
                      .utcOffset(dayjs().utcOffset())
                      .format('h:mm a, D MMM')}
                  </div>
                </MyAssessmentHeader>
                <GenericDisplayFlexColumn aic>
                  {datedData?.[selectedJournalIndex]?.assessmentResultList?.map(
                    (resultItem, indexResultItem) => {
                      const scoringRangeItem = resultItem?.scoringRangeList?.find(
                        (item) =>
                          item?.min <= resultItem?.userScore && item?.max >= resultItem?.userScore,
                      )

                      return (
                        <MyAssessmentChartAndDetailsContainer key={indexResultItem}>
                          <SpeedometerComponent
                            key={indexResultItem}
                            resultItem={resultItem}
                            indexResultItem={indexResultItem}
                            scoringRangeItem={scoringRangeItem}
                            labelTextWhite={true}
                            scale={0.7}
                          />
                          <GenericDisplayFlexColumn>
                            <MyAssessmentUserInputQA>{`Your ${resultItem?.domainName} score is ${resultItem?.userScore}/${resultItem?.totalScore}`}</MyAssessmentUserInputQA>
                            <MyAssessmentUserInputQA answer>
                              {scoringRangeItem?.interpretation}
                              <MyAssessmentSeeMoreText
                                detailedReportText
                                onClick={() => {
                                  setDetailedReportDrawerOpen(true)
                                  setDetailedReportWantedTab(resultItem?.domainId)
                                }}
                              >
                                Tap to read more.
                              </MyAssessmentSeeMoreText>
                            </MyAssessmentUserInputQA>
                          </GenericDisplayFlexColumn>
                        </MyAssessmentChartAndDetailsContainer>
                      )
                    },
                  )}
                </GenericDisplayFlexColumn>

                <YourInputsText>Your Inputs</YourInputsText>
                <DisplayFlexColumn style={{ gap: '8px' }}>
                  {datedData?.[selectedJournalIndex]?.journalQusAns?.map((qaItem, qaItemIndex) => {
                    return (
                      <>
                        <MyAssessmentUserInputQA>{`Q. ${qaItem?.question}`}</MyAssessmentUserInputQA>
                        <MyAssessmentUserInputQA
                          answer
                        >{`A. ${qaItem?.answere}`}</MyAssessmentUserInputQA>
                      </>
                    )
                  })}
                </DisplayFlexColumn>
              </AssessmentResultOverviewColoredContainer>
            )}

            <ChangeButtonsContainer right={selectedJournalIndex === 1}>
              {selectedJournalIndex > 1 && (
                <div className="flex align-items-center justify-center">
                  <JournalButton
                    src={left_arrow}
                    onClick={() => {
                      if (selectedJournalIndex > 1) {
                        if (datedData?.[selectedJournalIndex - 1]?.type === 'dateItem') {
                          setSelectedJournalIndex((prev) => prev - 2)
                        } else {
                          setSelectedJournalIndex((prev) => prev - 1)
                        }
                        let newScrollTop
                        if (indexAnswerVisible) {
                          newScrollTop = scrollTop - 272
                        } else {
                          newScrollTop = scrollTop - 182
                        }

                        setScrollTop(newScrollTop)
                        scrollRefEntries.current.scrollTop = newScrollTop
                      }
                    }}
                  />
                  <div>Previous</div>
                </div>
              )}
              {selectedJournalIndex < datedData?.length - 1 && (
                <div className="flex align-items-center justify-center">
                  <div>Next</div>
                  <JournalButton
                    src={left_arrow}
                    rotate
                    onClick={() => {
                      if (selectedJournalIndex < datedData?.length - 1) {
                        if (datedData?.[selectedJournalIndex + 1]?.type === 'dateItem') {
                          setSelectedJournalIndex((prev) => prev + 2)
                        } else {
                          setSelectedJournalIndex((prev) => prev + 1)
                        }
                        let newScrollTop
                        if (indexAnswerVisible) {
                          newScrollTop = scrollTop + 272
                        } else {
                          newScrollTop = scrollTop + 182
                        }
                        setScrollTop(newScrollTop)
                        scrollRefEntries.current.scrollTop = newScrollTop
                      }
                    }}
                  />
                </div>
              )}
            </ChangeButtonsContainer>
          </AnswerOverviewContainerParent>

          {recommendationDrawerOpen && <DarkOverlayBehindDrawer />}

          {recommendationData !== '' && !recommendationData?.noData && (
            <RecommendationDrawer recommendationDrawerOpen={recommendationDrawerOpen}>
              {!recommendationDrawerOpen && (
                <RecommendationClosedParentContainer
                  onClick={() => setRecommendationDrawerOpen((prev) => !prev)}
                >
                  <div className="flex align-items-center">
                    <RecommendsClosedTitle main>{recommendationData?.title}</RecommendsClosedTitle>
                    <GreenDotImage src={green_dot} />
                    <RecommendsClosedTitle>Tap here to Open</RecommendsClosedTitle>
                  </div>
                  <img src={caret_up} />
                </RecommendationClosedParentContainer>
              )}

              {recommendationDrawerOpen && (
                <RecommendationOpenParentContainer>
                  <ModalCloseButton
                    src={close_icon_purple}
                    onClick={() => setRecommendationDrawerOpen((prev) => !prev)}
                  />
                  <StyledHeading bold>{recommendationData?.title}</StyledHeading>
                  <RecommendationText>{recommendationData?.description}</RecommendationText>
                  <RecommendedItemContainer onClick={handleRecommendationClick}>
                    <RecommendedItemImage imgUrl={mediaURL + recommendationData?.imgId} />
                    {recommendationData?.itemTitle}
                  </RecommendedItemContainer>
                </RecommendationOpenParentContainer>
              )}
            </RecommendationDrawer>
          )}

          <DetailedReportDrawer
            className="drawer"
            anchor="bottom"
            open={detailedReportDrawerOpen}
            transitionDuration={{ enter: 600, exit: 300 }}
          >
            <img
              alt="close_button"
              src={close_icon_purple}
              style={{
                cursor: 'pointer',
                height: '20px',
                position: 'absolute',
                top: '30px',
                right: '30px',
              }}
              onClick={() => {
                setDetailedReportDrawerOpen(false)
                setDetailedReportWantedTab(null)
              }}
            />
            <DetailedReportComponent
              title="Your Report"
              detailedReportData={assessmentDetailedReportData}
              resultsData={datedData?.[selectedJournalIndex]?.assessmentResultList}
              tabId={detailedReportWantedTab}
            />
          </DetailedReportDrawer>

          {deleteWarningVisible && (
            <GenericModal
              warning="Warning"
              warningDesc="You will not be able to recover this."
              yes="I understand"
              onYes={() => {
                handleDeleteJournal()
                setDeleteWarningVisible(false)
              }}
              no="Cancel"
              isOpen={deleteWarningVisible}
              toggleFunc={() => setDeleteWarningVisible((prev) => !prev)}
            />
          )}
          {editReflectionVisible && (
            <ReflectiveQuestion
              edit
              questionOpen={editReflectionVisible}
              setIsQuestionOpen={() => setEditReflectionVisible((prev) => !prev)}
              questionData={datedData?.[selectedJournalIndex]}
              callSourceId="edit"
              afterSubmissionFunction={afterSubmitFunction}
            />
          )}
        </ScreenBackground>
      )}
    </>
  )
}
